import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { usePublishedSystemNotices } from '@/features/system-notices/hooks/usePublishedSystemNotices'
import { ChangelogSearchBar } from '@/features/company-pages/components/ChangelogSearchBar'
import { ChangelogTimeline } from '@/features/company-pages/components/ChangelogTimeline'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { PageHero } from '@/shared/components/marketing/PageHero'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'

export const Route = createFileRoute('/changelog')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/changelog']),
    links: generateLinks(routeSEO['/changelog']),
  }),
  component: ChangelogPage,
})

function ChangelogPage() {
  const [searchQuery, setSearchQuery] = useState('')
  const { data: notices, isLoading } = usePublishedSystemNotices()

  const filteredNotices = (notices ?? []).filter((notice) => {
    if (!searchQuery) return true
    const query = searchQuery.toLowerCase()
    return (
      notice.title.toLowerCase().includes(query) ||
      notice.body.toLowerCase().includes(query)
    )
  })

  return (
    <div className="relative flex min-h-screen flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      <Header />

      <main className="flex-1">
        <PageHero
          eyebrow="Updates"
          title="Changelog"
          lede="Track new features, improvements, and announcements."
        />
        <ChangelogSearchBar value={searchQuery} onChange={setSearchQuery} />
        <section className="w-full px-6 pt-16 pb-24 md:pt-20 md:pb-36">
          <div className="mx-auto max-w-6xl">
            <ChangelogTimeline
              notices={filteredNotices}
              isLoading={isLoading}
            />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}
